import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FrownOutlinedSvg from "@ant-design/icons-svg/es/asn/FrownOutlined";
import AntdIcon from "../components/AntdIcon";
var FrownOutlined = function FrownOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FrownOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FrownOutlined.displayName = 'FrownOutlined';
}
export default /*#__PURE__*/React.forwardRef(FrownOutlined);